import React from 'react';

export const EmptyViewTaxForm = () => (<div />);
